export default function Calendar({
  stroke = '#8FC045',
  width = '20',
  height = '20',
  style,
  onClick,
}) {
  return (
    <svg
      className={style}
      width={width}
      height={height}
      viewBox='0 0 20 20'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      onClick={() => {
        if (onClick) onClick()
      }}
    >
      <path
        d='M6.66667 1.66797V4.16797M13.3333 1.66797V4.16797M2.91667 7.5763H17.0833M17.5 7.08464V14.168C17.5 16.668 16.25 18.3346 13.3333 18.3346H6.66667C3.75 18.3346 2.5 16.668 2.5 14.168V7.08464C2.5 4.58464 3.75 2.91797 6.66667 2.91797H13.3333C16.25 2.91797 17.5 4.58464 17.5 7.08464Z'
        stroke={stroke}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.0816 11.418H13.0891M13.0816 13.918H13.0891M9.99823 11.418H10.0066M9.99823 13.918H10.0066M6.91406 11.418H6.9224M6.91406 13.918H6.9224'
        stroke={stroke}
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
